<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs8 offset-sm2>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{ responseError }}</span>
              </v-flex>
              <v-flex sm8>
                <v-flex sm12>
                  <v-text-field
                    name="username"
                    label="Username"
                    v-model="user.username"
                    type="text"
                    :disabled="user.id ? true : false"
                    :rules="[() => !!user.username || 'Username is required']"
                  ></v-text-field>
                </v-flex>
                <v-flex sm12 v-if="!user.id">
                  <v-text-field
                    name="password"
                    label="Password"
                    v-model="user.password"
                    type="password"
                    :rules="[
                      () => !!user.password || 'Password is required',
                      () =>
                        (user.password && user.password.length > 5) ||
                        'Password length must be greater than or equal to 6 characters',
                    ]"
                  ></v-text-field>
                </v-flex>
                <v-flex sm12 v-if="!user.id">
                  <v-text-field
                    name="confirmPassword"
                    label="Confirm Password"
                    v-model="user.confirmPassword"
                    type="password"
                    :rules="[
                      () =>
                        !!user.confirmPassword ||
                        'Confirm Password is required',
                      () =>
                        user.password == user.confirmPassword ||
                        'Password and confirm password does not match',
                    ]"
                  ></v-text-field>
                </v-flex>
                <v-flex sm12>
                  <v-select
                    :disabled="user.id ? true : false"
                    :items="roleNameList"
                    v-model="user.roleName"
                    label="Select role name"
                    :rules="[() => !!user.roleName || 'Role Name is required']"
                    @change="clearData()"
                  ></v-select>
                </v-flex>
                <v-flex sm12>
                  <v-select
                    :items="shopList"
                    v-model="user.ledgerBy"
                    label="Ledger By"
                    item-text="name"
                    item-value="id"
                    :rules="[() => !!user.ledgerBy || 'Ledger By is required']"
                  ></v-select>
                </v-flex>
                <v-flex
                  sm12
                  v-if="
                    user.roleName &&
                      (user.roleName == 'SALE_MANAGER' ||
                        user.roleName == 'GENERAL_MANAGER' ||
                        user.roleName == 'SALE' ||
                        user.roleName == 'MARKETING' ||
                        user.roleName == 'PRODUCTION_MANAGER' ||
                        user.roleName == 'BRANCH_ADMIN' ||
                        user.roleName == 'ASSET_MANAGER')
                  "
                >
                  <v-select
                    :items="shopList"
                    v-model="user.shopId"
                    label="Select Shop"
                    item-text="name"
                    item-value="id"
                    @change="
                      user.roleName == 'BRANCH_ADMIN'
                        ? getWarehouseByShopId()
                        : ''
                    "
                    :rules="[() => !!user.shopId || 'Shop is required']"
                  ></v-select>
                </v-flex>
                <v-flex
                  sm12
                  v-if="
                    user.roleName &&
                      (user.roleName == 'WAREHOUSE_MANAGER' ||
                        user.roleName == 'WAREHOUSE_STAFF' ||
                        user.roleName == 'STORE_KEEPER' ||
                        user.roleName == 'MARKETING' ||
                        user.roleName == 'BRANCH_ADMIN' ||
                        user.roleName == 'PROCUREMENT_MANAGER')
                  "
                >
                  <v-select
                    :items="warehouseList"
                    v-model="user.warehouseId"
                    label="Select Warehouse"
                    item-text="name"
                    item-value="id"
                    :rules="
                      user.roleName === 'PROCUREMENT_MANAGER'
                        ? []
                        : [() => !!user.warehouseId || 'Warehouse is required']
                    "
                    @change="getBinListByWarehouse()"
                    :readonly="user.roleName == 'BRANCH_ADMIN'"
                    :clearable="user.roleName == 'PROCUREMENT_MANAGER'"
                  ></v-select>
                </v-flex>
                <v-flex
                  sm12
                  v-if="user.roleName && user.roleName == 'WAREHOUSE_STAFF'"
                >
                  <v-select
                    v-model="user.binIds"
                    :items="binList"
                    label="Select Bin..."
                    item-text="name"
                    item-value="id"
                    multiple
                    chips
                    small-chips
                    clearable
                    menu-props="auto"
                    :rules="[() => user.binIds.length > 0 || 'Bin is required']"
                  ></v-select>
                </v-flex>
                <v-flex
                  sm12
                  v-if="
                    user.roleName &&
                      (user.roleName == 'SALE_MANAGER' ||
                        user.roleName == 'SALE')
                  "
                >
                  <v-select
                    :items="saleTeamList"
                    v-model="user.saleTeamId"
                    label="Select Sale Team"
                    item-text="name"
                    item-value="id"
                    :rules="[
                      () => !!user.saleTeamId || 'Sale Team is required',
                    ]"
                  ></v-select>
                </v-flex>
                <!-- <v-flex
                  sm12
                  v-if="user.roleName && user.roleName == 'ASSET_MANAGER'"
                >
                  <v-select
                    :items="branchList"
                    v-model="user.branchId"
                    label="Select Branch"
                    item-text="name"
                    item-value="id"
                    :rules="[() => !!user.branchId || 'Branch is required']"
                  ></v-select>
                </v-flex> -->
                <v-flex sm12 v-if="user.id">
                  <v-menu
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    :disabled="true"
                  >
                    <v-text-field
                      slot="activator"
                      label="Created Date"
                      type="text"
                      prepend-icon="event"
                      v-model="createdDate"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="createdDate"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex sm12 v-if="user.id">
                  <v-text-field
                    name="createdBy"
                    label="Created By"
                    v-model="user.createdBy"
                    type="text"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex sm12 v-if="user.id">
                  <v-menu
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    :disabled="true"
                  >
                    <v-text-field
                      slot="activator"
                      label="Updated Date"
                      type="text"
                      prepend-icon="event"
                      v-model="updatedDate"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="updatedDate"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex sm12 v-if="user.id">
                  <v-text-field
                    name="updateBy"
                    label="Updated By"
                    v-model="user.updatedBy"
                    type="text"
                    readonly
                  ></v-text-field>
                </v-flex>
              </v-flex>
              <v-flex sm4>
                <div style="height: 25px"></div>
                <div style="height: 20px">
                  <v-label>Signature</v-label>
                </div>
                <div style="height: 5px"></div>
                <div class="form-group dropbox" v-if="!user.signature">
                  <input
                    type="file"
                    @change="onFileChanged"
                    accept="image/jpg, image/jpeg, image/png"
                    class="input-file"
                  />
                  <p>
                    Drag your file(s) here to begin
                    <br />or click to browse
                  </p>
                </div>
                <div v-if="user.signature">
                  <img :src="user.signature" width="200" height="100" />
                  <button
                    style="float: right"
                    @click="removeImage"
                    class="close"
                    type="button"
                  >
                    <v-icon color="red">cancel</v-icon>
                  </button>
                </div>
                <div></div>
              </v-flex>
              <v-flex sm4 v-if="user.id">
                <v-switch
                  :label="`Status is ${statusFlag ? 'Active' : 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex sm4 v-if="user.id">
                <v-btn
                  flat
                  color="primary"
                  @click="showChangePwdModal()"
                  style="float: right"
                  >Change Password?</v-btn
                >
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="!valid"
                    type="submit"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex xs6 offset-sm3></v-flex>
      </v-layout>
    </v-form>
    <!----------------- For Change Password Dialog --------------------->

    <v-dialog v-model="openDialog" persistent max-width="350">
      <v-form
        ref="modalForm"
        v-model="modalValid"
        lazy-validation
        @submit.prevent="changePassword"
      >
        <v-card>
          <v-card-title primary-title class="headline blue darken-2">
            <span class="white--text">Change Password</span>
          </v-card-title>
          <v-divider></v-divider>
          <div class="ma-3">
            <v-flex sm12>
              <v-text-field
                name="username"
                label="Username"
                v-model="modalUser.username"
                type="text"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex sm12>
              <v-text-field
                name="password"
                label="Password"
                v-model="modalUser.password"
                type="password"
                :rules="[
                  () => !!modalUser.password || 'Password is required',
                  () =>
                    (modalUser.password && modalUser.password.length > 5) ||
                    'Password length must be greater than or equal to 6 characters',
                ]"
              ></v-text-field>
            </v-flex>
            <v-flex sm12>
              <v-text-field
                name="confirmPassword"
                label="Confirm Password"
                v-model="modalUser.confirmPassword"
                type="password"
                :rules="[
                  () =>
                    !!modalUser.confirmPassword ||
                    'Confirm Password is required',
                  () =>
                    modalUser.password == modalUser.confirmPassword ||
                    'Password and confirm password does not match',
                ]"
              ></v-text-field>
            </v-flex>
          </div>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" flat @click.native="openDialog = false"
              >Cancel</v-btn
            >
            <v-btn color="primary" flat type="submit">Change Password</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import { userService } from "../../services/user-service";
import { User } from "../../models/model";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { warehouseService } from "../../services/warehouse-service";
import { shopService } from "../../services/shop-service";
import { saleTeamService } from "../../services/sale-team-service";
import { commonService } from "../../services/common-service";
import { binService } from "../../services/bin-service";
import { branchService } from "../../services/branch-service";

export default {
  name: "UserDetail",
  components: { VSwitch },
  data: () => ({
    openDialog: false,
    valid: true,
    modalValid: true,
    breadcrumbs: [
      {
        text: "Users",
        disabled: false,
        to: "users",
      },
      {
        text: "User Detail",
        disabled: true,
      },
    ],
    createdDate: "",
    updatedDate: "",
    user: new User(),
    oldUser: new User(),
    statusFlag: true,
    roleNameList: [],
    warehouseList: [],
    shopList: [],
    saleTeamList: [],
    binList: [],
    branchList: [],
    saveLoading: false,
    responseError: "",
    modalError: "",
    modalUser: new User(),
  }),
  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      // new user
    } else {
      this.getUserDetail(id);
    }

    this.getAllRoles();
    this.getAllWarehouses();
    this.getAllShop();
    this.getActiveSaleTeams();
    this.getBranchList();
  },
  methods: {
    changePassword() {
      if (this.$refs.modalForm.validate()) {
        userService
          .changePasswordById(this.modalUser)
          .then((res) => {
            console.log(res);
            this.goBack();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    showChangePwdModal() {
      this.$refs.modalForm.resetValidation();
      this.openDialog = true;
      this.modalUser.username = this.user.username;
      this.modalUser.id = this.user.id;
    },
    getAllRoles() {
      userService
        .getUserRoleList()
        .then((res) => {
          this.roleNameList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllWarehouses() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getWarehouseByShopId() {
      let shop = this.shopList.find((v) => v.id == this.user.shopId);
      if (shop) {
        this.user.warehouseId = shop.warehouseId;
      }
    },
    getAllShop() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getActiveSaleTeams() {
      saleTeamService
        .getSaleTeamsByStatus("ACTIVE")
        .then((res) => {
          this.saleTeamList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getUserDetail(id) {
      userService
        .getUserDetail(id)
        .then((res) => {
          this.user = res.data;
          if (this.user.binList) {
            this.binList = this.user.binList;
          }
          this.createdDate = commonService.formatDate(
            new Date(this.user.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.user.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.oldUser = Object.assign({}, res.data);
          this.statusFlag = this.user.status == "ACTIVE" ? true : false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.user.status = this.statusFlag ? "ACTIVE" : "INACTIVE";
        let userObj = {
          id: this.user.id ? this.user.id : "",
          username: this.user.username,
          password: this.user.password,
          roleName: this.user.roleName,
          warehouseId: this.user.warehouseId,
          warehouseName: this.user.warehouseName,
          shopId: this.user.shopId,
          saleTeamId: this.user.saleTeamId,
          status: this.user.status,
          signature: this.user.signature,
          image: this.user.image,
          binIds: this.user.binIds,
          branchId: this.user.branchId,
          ledgerBy: this.user.ledgerBy,
        };
        userService
          .saveUser(userObj)
          .then((res) => {
            console.log(res);
            this.goBack();
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.user.id) {
        this.user = new User();
        this.statusFlag = true;
      } else {
        this.user = Object.assign({}, this.oldUser);
        this.statusFlag = this.user.status == "ACTIVE" ? true : false;
      }

      this.responseError = "";
    },
    goBack() {
      this.$router.push("/users");
    },
    removeImage() {
      this.user.signature = null;
    },
    onFileChanged(event) {
      const file = event.target.files[0];
      this.user.signature = URL.createObjectURL(file); // to show preview image
      commonService.getBase64(file).then((data) => {
        this.user.image = data;
      });
    },
    getBinListByWarehouse() {
      this.user.binIds = [];
      binService
        .getBinsByWarehouseAndStatus(this.user.warehouseId, "ACTIVE")
        .then((res) => {
          this.binList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getBranchList() {
      branchService
        .getBranchByStatus("ACTIVE")
        .then((res) => {
          this.branchList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    clearData() {
      this.user.shopId = "";
      this.user.warehouseId = "";
      this.user.binIds = [];
      this.user.saleTeamId = "";
    },
  },
};
</script>

<style scoped></style>
